import { configureStore } from "@reduxjs/toolkit";
import authReducer from "./slices/authSlice";
import usersReducer from "./slices/userSlice";
import vendorsReducer from "./slices/vendorSlice";
import payoutsReducer from "./slices/payOut";
import orderReducer from "./slices/orderSlice";
import categoryAnalyticsReducer from "./slices/categoryAnalyticsSlice";
import subscriberReducer from "./slices/subscriberSlice";
import notificationsReducer from "./slices/notificationsSlice";

const store = configureStore({
  reducer: {
    auth: authReducer,
    users: usersReducer,
    vendors: vendorsReducer,
    payouts: payoutsReducer,
    orders: orderReducer,
    categoryAnalytics: categoryAnalyticsReducer,
    subscribers: subscriberReducer,
    notifications: notificationsReducer,
  },
});

export default store;
